import { useReplaceLocation } from '../contact'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useLocationCache } from '../location'
import { useTantalimMutation } from '../mutation'
import { type OnLocationMutate } from './types'
import {
  Logger,
  toResponseError,
  type ExtendedLocationData,
  type LocationNoteInput,
  type LocationNoteSuccess,
} from '@terros/common'

const logger = new Logger('note')

export function useAddLocationNote(
  onMutate: OnLocationMutate
): AddHookResponse<LocationNoteInput, ExtendedLocationData> {
  const replaceLocation = useReplaceLocation()
  const { replaceItem } = useLocationCache()

  const mutation = useTantalimMutation<LocationNoteInput, LocationNoteSuccess>({
    url: '/location/note',
  })

  async function add(input: LocationNoteInput): Promise<ExtendedLocationData> {
    const { locationId } = input
    try {
      const { location: newLocation } = await mutation.mutateAsync({ version: 3, ...input })
      logger.verbose('saved location', newLocation)

      replaceLocation({
        locationId,
        newLocation,
      })
      replaceItem(locationId, newLocation)
      await onMutate(locationId, newLocation.locationId)
      return newLocation
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
